export default function appendQueryStringToUrl(url, queryString) {
  if (!queryString) {
    return url;
  }

  return `${url}${url.indexOf("?") === -1 ? "?" : "&"}${queryString}`;
}

export function appendSearchToUrl(url, search = "") {
  if (!url || !search) {
    return url;
  }

  return `${url}${search.startsWith("?") ? search : `?${search}`}`;
}
